export default __webpack_public_path__ + "images/78c136d7cbd6fcfee983ad7c2adae400-classes.jpg";